import _ from "lodash";
import { Box, Typography } from "@mui/material";
import { theme } from "app/App";
import BasicTable from "components/basic/BasicTable";
import { getIndicadorByField } from "entity/Indicador/all";

const columns = [
    { field: "IndicadorClass.abbrev", headerName: "Indicador", flex: 1 },
    { field: "apontamento.tipo", headerName: "Tipo", flex: 1 },
    {
        field: "apontamento.talhao.nome",
        headerName: "Talhão",
        flex: 1,
        valueGetter: (v) => {
            if (v.apontamento.talhao.length) {
                let originalString = ''

                let talhoes = v.apontamento.talhao

                let orderedTalhoes = talhoes.sort(function (a, b) {
                    // Converte os valores para números antes de comparar
                    var nomeA = parseInt(a.nome)
                    var nomeB = parseInt(b.nome)

                    if (nomeA < nomeB) {
                        return -1
                    }
                    if (nomeA > nomeB) {
                        return 1
                    }
                    return 0
                })

                for (let i = 0; i < orderedTalhoes.length; i++) {
                    originalString = originalString + orderedTalhoes[i].nome + ", "
                }

                let modifiedString = originalString.slice(0, -2)
                modifiedString = modifiedString.replace(/,([^,]*)$/, ' e$1')

                return modifiedString
            } else {
                return v.apontamento.talhao.nome
            }
        }
    },
    { field: "apontamento.conformidade", headerName: "(%)", flex: 1, align: "right" },
];

/**
 * Lista os apontamentos de uma visita para edição.
 */
export default function ApontamentoList({ TipoClass, visita, onSelect, hideEmpty = true }) {
    const apontamentos = visita.getApontamentosByTipo(TipoClass);
    const rows = [];

    for (const indicador in apontamentos) {
        const IndicadorClass = getIndicadorByField(indicador);

        apontamentos[indicador].forEach((apontamento, index) => {
            rows.push({
                IndicadorClass: IndicadorClass,
                index: index,
                apontamento: apontamento,
            });
        });
    }

    function handleSelect(...args) {
        if (onSelect) {
            onSelect(...args);
        }
    }

    return _.isEmpty(rows) && hideEmpty ? null : (
        <Box>
            {/* TODO: mover cores para o tema */}
            <Typography
                variant="h6"
                sx={{
                    p: 1,
                    display: "flex",
                    backgroundColor: theme.palette.grey[800],
                    flex: 1,
                    fontSize: "1em",
                    color: "white",
                }}
            >
                {TipoClass.fullName}
            </Typography>

            <Box sx={{ mb: 2 }}>
                <BasicTable columns={columns} rows={rows} onRowClick={handleSelect} />
            </Box>
        </Box>
    );
}
